
let env;

if (window.location.host.includes('dev.nihl.wsib.ca')) {
  env = {    
    "production": false,
    "apiUrl": "https://dev.nihl.wsib.ca",
    "authorityUrlStart": "https://securelogindev.wsib.ca/wsibdev1.onmicrosoft.com/B2C_1A_NIHL_start_submission/v2.0",
    "authorityUrlContinue": "https://securelogindev.wsib.ca/wsibdev1.onmicrosoft.com/B2C_1A_NIHL_continue_submission/v2.0",
    "client_id": "c8cfd969-74ab-4e54-ae1a-6abf793d75fb",
    "redirect_uri": "https://dev.nihl.wsib.ca/auth-callback",
    "redirect_resume_uri": "https://dev.nihl.wsib.ca/auth-resume-callback",
    "post_logout_uri": "https://dev.nihl.wsib.ca/auth-logout",
    "scope": "openid offline_access https://wsibdev1.onmicrosoft.com/nihlapi/apiaccess",
    "timeOut": "14",
    "google": "AIzaSyDZ0sFfZb1oMheLgDpy9CyFStZcOhSutds"
  }
} else if (window.location.host.includes('ppd.hearing-loss-claim.wsib.ca')) {
  env = {    
    "production": false,
    "apiUrl": "https://ppd.hearing-loss-claim.wsib.ca",
    "authorityUrlStart": "https://secureloginppd.wsib.ca/wsibb2cppd.onmicrosoft.com/B2C_1A_NIHL_start_submission/v2.0",
    "authorityUrlContinue": "https://secureloginppd.wsib.ca/wsibb2cppd.onmicrosoft.com/B2C_1A_NIHL_continue_submission/v2.0",
    "client_id": "2f2e2477-5e0c-4e8d-9548-5857f7c0bc4d",
    "redirect_uri": "https://ppd.hearing-loss-claim.wsib.ca/auth-callback",
    "redirect_resume_uri": "https://ppd.hearing-loss-claim.wsib.ca/auth-resume-callback",
    "post_logout_uri": "https://ppd.hearing-loss-claim.wsib.ca/en/nihl/logout",
    "scope": "openid offline_access https://wsibb2cppd.onmicrosoft.com/nihlapi/apiaccess",
    "timeOut": "14",
    "google": "AIzaSyDZ0sFfZb1oMheLgDpy9CyFStZcOhSutds"
  }
} else if (window.location.host.includes('localhost:4230')) {
  env = {
    production: false,
    apiUrl: 'http://localhost:4230',
    authorityUrlStart: 'https://securelogindev.wsib.ca/wsibdev1.onmicrosoft.com/B2C_1A_NIHL_start_submission/v2.0',
    authorityUrlContinue: 'https://securelogindev.wsib.ca/wsibdev1.onmicrosoft.com/B2C_1A_NIHL_continue_submission/v2.0',
    client_id: '90caf621-66a6-43ca-a801-b7156b8149f2',
    redirect_uri: 'http://localhost:4230/auth-callback',
    redirect_resume_uri: 'http://localhost:4230/auth-resume-callback',
    post_logout_uri: 'http://localhost:4230/auth-logout',
    scope: 'openid offline_access https://wsibdev1.onmicrosoft.com/nihlapi/apiaccess',
    timeOut: 14,
    google: 'AIzaSyDZ0sFfZb1oMheLgDpy9CyFStZcOhSutds'
  };
} else {
  // default to prod deployment of 'hearing-loss-claim.wsib.ca'
  env = {
    "production": false,
    "apiUrl": "https://hearing-loss-claim.wsib.ca",
    "authorityUrlStart": "https://securelogin.wsib.ca/wsibb2c.onmicrosoft.com/B2C_1A_NIHL_start_submission/v2.0",
    "authorityUrlContinue": "https://securelogin.wsib.ca/wsibb2c.onmicrosoft.com/B2C_1A_NIHL_continue_submission/v2.0",
    "client_id": "604d5ae0-1028-4bae-8af3-16a7b589d4dd",
    "redirect_uri": "https://hearing-loss-claim.wsib.ca/auth-callback",
    "redirect_resume_uri": "https://hearing-loss-claim.wsib.ca/auth-resume-callback",
    "post_logout_uri": "https://hearing-loss-claim.wsib.ca/en/nihl/logout",
    "scope": "openid offline_access https://wsibb2c.onmicrosoft.com/nihlapi/apiaccess",
    "timeOut": "14",
    "google": "AIzaSyDZ0sFfZb1oMheLgDpy9CyFStZcOhSutds"
  }
}
  
console.log(window.location.host)
console.log('environment: \r\n'+ JSON.stringify(env) );

export const environment = env;
